<template>
    <div class="weui-panel" v-if="!!info">
        <div class="weui-panel__bd">
            <div class="weui-media-box weui-media-box_appmsg">
                <div class="weui-media-box__hd" v-show="info.avatar">
                    <img class="weui-media-box__thumb" :src="info.avatar" alt="">
                </div>
                <div class="weui-media-box__bd">
                    <h4 class="weui-media-box__title">{{info.name}}</h4>
                    <ul class="weui-media-box__info">
                        <li class="weui-media-box__info__meta" :class="index > 0 ? 'weui-media-box__info__meta_extra' : ''" 
                            v-for="(s, index) in info.extra" :key="index">{{s}}</li>
                        <li class="weui-media-box__info__meta weui-media-box__info__meta_extra" v-if="info.button.includes('renew')">
                            <router-link :to="renewRoute">续费</router-link>
                        </li>
                        <li class="weui-media-box__info__meta weui-media-box__info__meta_extra" v-if="info.button.includes('join')">
                            <router-link :to="renewRoute">加入会员</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * info: [
 *  avatar
 *  name
 *  extra: []
 *  button: []
 * ]
 */
export default {
    name: "MyInfo",
    props: [
        "info"
    ],
    computed: {
        renewRoute() {
            return {
                path: `/user/member`
            }
        }
    },
}
</script>